<div class="modal-content funding">
    <div class="modal-header border-0">
        <h3 class="modal-title" id="modulesModalLabel">Registrar evento <span *ngIf="typeAction == 'related'">relacionado</span></h3>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form [formGroup]="evidenceFrom"  class="row needs-validation" novalidate="">
            <div class="row">
                <p class="text-info"><span *ngIf="typeAction == 'related'">Este evento está relacionado con el evento número <strong>{{ data["idEvent"] }}</strong></span></p>
            </div>
            <div class="row">
                <div class="mb-3 col-sm-6">
                    <label for="service_id">Orden de Servicio: <span class="txt-danger"> *</span></label>
                    <!-- Select Field -->
                    <select class="form-select" id="service_id" required="true" formControlName="service_id">
                        <option *ngFor="let service of serviceList" [value]="service.id">
                            {{ service.value }}
                        </option>
                    </select>
                    <div class="valid-feedback"></div>
                </div>
                <div class="mb-3 col-sm-6">
                    <label for="event_date">Fecha del evento: <span class="txt-danger"> *</span></label>
                    <input class="form-control" id="event_date" type="date" required="true" formControlName="event_date"/>
                    <div class="valid-feedback"></div>
                </div>
                <div class="mb-3 col-sm-12">
                    <label class="col-12 form-label m-0" for="amount">Monto: <span class="txt-danger"> *</span></label>
                    <div class="col-12 input-group"><span class="input-group-text">$</span>
                        <input class="form-control" type="text" id="amount" aria-label="($MXN)" formControlName="amount">
                        <span class="input-group-text">MXN</span>
                    </div>
                </div>
                <div class="mb-3 col-sm-6">
                    <label>Asignado a: <span class="txt-danger"> *</span></label>
                    <div class="m-checkbox-inline">
                        <label for="edo-ani">
                            <input class="radio_animated" id="edo-ani" type="radio" formControlName="assigned" [value]="1">Cliente
                        </label>
                        <label for="edo-ani1">
                            <input class="radio_animated" id="edo-ani1" type="radio" formControlName="assigned" [value]="2">Empresa
                        </label>
                    </div>
                </div>
                <div class="mb-3 col-sm-6">
                    <label>Deducible a: <span class="txt-danger"> *</span></label>
                    <div class="m-checkbox-inline">
                        <label for="edo-ani">
                            <input class="radio_animated" id="edo-ani3" type="radio" formControlName="deductible" [value]="1">Si
                        </label>
                        <label for="edo-ani1">
                            <input class="radio_animated" id="edo-ani4" type="radio" formControlName="deductible" [value]="0">No
                        </label>
                    </div>
                </div>
                <div class="mb-3 col-sm-6">
                    <div class="col-form-label">Tipo evento: <span class="txt-danger"> *</span>
                        <!-- Select Field -->
                        <select class="form-select" id="event_type_id" required="true" formControlName="event_type_id">
                            <option *ngFor="let option of typeEventlist" [value]="option.id">
                                {{ option.value }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="mb-3 col-sm-6">
                    <div class="col-form-label">Motivo: <span class="txt-danger"> *</span>
                        <!-- Select Field -->
                        <select class="form-select" id="reason_id" required="true" formControlName="reason_id">
                            <option *ngFor="let option of reasonEventlist" [value]="option.id">
                                {{ option.value }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="email-wrapper">
                    <div class="theme-form">
                        <div class="mb-3">
                            <label class="w-100">Descripción:</label>
                            <!-- Textarea Field -->
                            <textarea class="form-control" id="event_description" placeholder=""
                                    rows="3" formControlName="event_description"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="card-body transaction-list recent-orders">
            <div class="row mt-4">
                <div class="col-md-12 mb-3">
                    <div class="mb-3">
                        <label>Evidencias</label>
                        <form class="dropzone dropzone-light custom-scrollbar customize-dropzone">
                            <dropzone [config]="config" [message]="textDropzone" (init)="onDropzoneInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)" (removedFile)="onRemoveSuccess($event)">
                            </dropzone>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- Botones form-->
        <div class="d-flex justify-content-end gap-2 mt-2">
            <button type="button" class="btn btn-secondary col-auto" (click)="cancelForm()">Cancelar</button>
            <button type="button" class="btn btn-primary col-auto" (click)="addNewEvent()">Agregar</button>
        </div>
    </div>
</div>
